import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import GetData from "../../services/getData";
import { Col, Container, Form, Row } from "react-bootstrap";
import TitleWithIcon from "../../components/layout/pageTitle/PageTitle";
import employeesIcon from "../../media/icons8-hierarchy.png";
import BlockTitle from "../../components/layout/blockTitle/BlockTitle";
import undefinedStaff from "../../media/underfined_staff.png";
import "./employees.css";

function EmployeesProfile() {
  const { t } = useTranslation("staff");
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [formData, setFormData] = useState({
    name: "",
  });
  const [isEditing, setIsEditing] = useState(false);

  const { id } = useParams();
  const id_staff = Number(id);

  const fetchEmployee = async (id_staff) => {
    setLoading(true);
    setError(null);
    try {
      const data = await GetData({
        module: "staff",
        block: "info",
        id_staff,
      });

      let employeeData = data.result || {};

      if (Array.isArray(employeeData) && employeeData.length > 0) {
        employeeData = employeeData[0];
      }

      if (typeof employeeData !== "object" || employeeData === null) {
        employeeData = {};
      }

      setEmployees(employeeData);
    } catch (err) {
      console.error("Ошибка загрузки услуги:", err);
      setError(err.message || t("profile.errors.loadFailed"));
    } finally {
      setLoading(false);
    }
  };


  // Загружаем услугу при изменении id
  useEffect(() => {
    if (id_staff) {
      fetchEmployee(id_staff);
    } else {
      setEmployees({});
      setLoading(false);
    }
  }, [id_staff]);

  useEffect(() => {
    setFormData({
      name: employees.name?.value || "",
      type: employees.type?.value || "",
      post: employees.post?.value || "",
      phone: employees.phone?.value || "",
      clinics: employees.clinics?.value || "",
      all_clinics: employees.all_clinics?.value || "",
    });
  }, [employees]);

  
  useEffect(() => {
    if (employees?.name?.value) {
      document.title = employees.name.value;
    }
  }, [employees]);

  const selectedClinicIds = Array.isArray(formData.clinics)
    ? formData.clinics.map((clinic) => clinic?.id ?? "")
    : [];

  const handleSave = async () => {
    try {
      // Подготавливаем данные для отправки — с обёрткой { value: ... }
      const clinicIds = Array.isArray(formData.clinics)
        ? formData.clinics.map((clinic) => clinic.id)
        : [];

      const updatedData = {
        name: { value: formData.name },
        type: { value: formData.type },
        post: { value: formData.post },
        phone: { value: formData.phone },
        clinics: { value: clinicIds },
      };

      console.log(updatedData);

      // Отправляем изменения на сервер
      await GetData({
        module: "staff",
        block: "info",
        id_staff: id_staff,
        action: "change",
        data: updatedData,
      });

      await fetchEmployee(id_staff);

      setIsEditing(false);
    } catch (err) {
      console.error("Ошибка сохранения:", err);
      alert(t("profile.errors.saveFailed"));
    }
  };
  const handleCancel = () => {
    setFormData({
      name: employees.name?.value || "",
      type: employees.type?.value || "",
      post: employees.post?.value || "",
      phone: employees.phone?.value || "",
      clinics: employees.clinics?.value || "",
      all_clinics: employees.all_clinics?.value || "",
    });
    setIsEditing(false);
  };

  const handleEdit = () => {
    setIsEditing(true);
  };

  const handleChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  // Защита от рендера до загрузки (опционально, но рекомендуется)
  if (loading) {
    return (
      <Container fluid="md" className="mt-4">
        {t("profile.loading")}
      </Container>
    );
  }

  if (error) {
    return (
      <Container fluid="md" className="mt-4">
        {t("error", { ns: "common", message: error })}
      </Container>
    );
  }

  return (
    <Container fluid="md">
      <Row>
        <Col>
          <div className="staff-page">
            <TitleWithIcon
              icon={employeesIcon}
              title={formData.name || t("profile.untitled")}
              showStatus={false}
              status={""}
            />
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <div className="tab-content block page-block">
            <Row>
              <Col>
                <BlockTitle
                  title=""
                  buttons={
                    isEditing
                      ? [
                          {
                            label: t("profile.save"),
                            onClick: handleSave,
                            type: "normal",
                          },
                          {
                            label: t("profile.cancel"),
                            onClick: handleCancel,
                            type: "light",
                          },
                        ]
                      : [
                          {
                            label: t("profile.edit"),
                            onClick: handleEdit,
                            type: "light icon",
                          },
                        ]
                  }
                />
              </Col>
            </Row>

            <div className="staff-container mt-lg-4">
              <Row>
                <Col md={4}>
                  <div className="staff-img">
                    <img
                      src={undefinedStaff}
                      alt={t("profile.imageAlt")}
                      title={t("profile.imageAlt")}
                      className="img-fluid"
                    />
                  </div>
                </Col>
                <Col md={8}>
                  <div className="staff-content">
                    {isEditing ? (
                      <select
                        className="form-control mb-2 type-staff"
                        value={formData.type}
                        onChange={(e) => handleChange("type", e.target.value)}>
                        <option value="Врач">{t("types.doctor")}</option>
                        <option value="Медсестра/Медбрат">
                          {t("types.nurse")}
                        </option>
                        <option value="Администратор">{t("types.admin")}</option>
                      </select>
                    ) : (
                      <div className="type-staff">{formData.type}</div>
                    )}
                    {/* Название */}
                    <div className="title-staff-content">
                      {isEditing ? (
                        <>
                          <input
                            type="text"
                            className="form-control mb-2 title-staff"
                            value={formData.name}
                            placeholder={t("profile.namePlaceholder")}
                            onChange={(e) =>
                              handleChange("name", e.target.value)
                            }
                          />
                          <input
                            type="text"
                            className="form-control mb-2 post-staff"
                            value={formData.post}
                            placeholder={t("profile.postPlaceholder")}
                            onChange={(e) =>
                              handleChange("post", e.target.value)
                            }
                          />
                          <input
                            type="text"
                            className="form-control mb-2 phone-staff"
                            value={formData.phone}
                            placeholder={t("profile.phonePlaceholder")}
                            onChange={(e) =>
                              handleChange("phone", e.target.value)
                            }
                          />

                          <Form.Select
                            multiple
                            value={selectedClinicIds}
                            onChange={(e) => {
                              const selectedIds = Array.from(
                                e.target.selectedOptions,
                                (opt) => opt.value,
                              );
                              const selectedClinics =
                                formData.all_clinics?.filter((clinic) =>
                                  selectedIds.includes(String(clinic.id)),
                                ) || [];
                              handleChange("clinics", selectedClinics);
                            }}
                            size={12}>
                            {formData?.all_clinics?.map((clinic) => (
                              <option key={clinic.id} value={String(clinic.id)}>
                                {" "}
                                {/* явно строка */}
                                {clinic.name}
                              </option>
                            ))}
                          </Form.Select>
                          <div className="text-muted small mt-1">
                            {t("profile.clinicsHint")}
                          </div>
                        </>
                      ) : (
                        <>
                          <div className="title-staff">{formData.name}</div>
                          <div className="staff-post">{formData.post}</div>
                          <div className="staff-phone">{formData.phone}</div>
                          <div className="staff-clinic">
                            {formData.clinics && formData.clinics.length > 0 ? (
                              <div className="doctors-clinic-table">
                                {formData.clinics.map((clinic) => (
                                  <Link
                                    key={clinic.id}
                                    to={`/contacts/${clinic?.id}/`}
                                    className="link-doctor">
                                    <div className="link-doctor-block">
                                      {clinic?.name}
                                    </div>
                                  </Link>
                                ))}
                              </div>
                            ) : (
                              "—"
                            )}
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
}

export default EmployeesProfile;
